import { useEffect, useState, useCallback } from 'react';
import { MY_PROFILE_QUESTION_SECTIONS_V2, SUCCESS } from '../../../../services/constants';
import { getLearnerQuestionaire } from '../../../../../util/APIUtils';

export const useInsightsV2Hook = (props) => {
  const { user } = props;
  const fullName = user && `${user.firstName || ''} ${user.lastName || ''}`;

  const [isLoading, setIsLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      setIsLoading(true);
      const response = await getLearnerQuestionaire(user.userId);
      if (response.status === SUCCESS) {
        const { payload } = response;
        const withName = appendNameToQuestions(payload.questions, payload.answers || []);
        const questionsWithAnswers = mapAnswersToQuestions(withName.questions, withName.answers);
        setQuestions(questionsWithAnswers);
        setAnswers(withName.answers);
      }
    } catch (e) {
      console.log(e);
    }
    setIsLoading(false);
  };

  const appendNameToQuestions = useCallback(
    (quest, ans = []) => {
      const nameQuestion = {
        id: 'name_field',
        section: 'Basic Information',
        code: 'NAME',
        question: 'Name',
        questionType: 'DROPDOWN',
        helpText: null,
        maxSelection: 1,
        displayOrder: 0,
        isReadOnly: true,
        answerOptions: [
          {
            id: 'name_option',
            displayValue: fullName,
            displayOrder: 1,
          },
        ],
      };

      const updatedQuestions = [nameQuestion, ...quest];
      const updatedAnswers = [{ questionId: 'name_field', answerOptionIds: ['name_option'] }, ...ans];

      return {
        questions: updatedQuestions,
        answers: updatedAnswers,
      };
    },
    [fullName]
  );

  const mapAnswersToQuestions = useCallback((questions, answers) => {
    return questions.map((question) => {
      const questionCopy = JSON.parse(JSON.stringify(question));

      if (question.id === 'name_field') {
        return {
          ...questionCopy,
          answer: 'name_option',
        };
      }

      const answer = answers.find((answer) => answer.questionId === question.id);
      if (answer && answer.answerOptionIds) {
        questionCopy.answer = questionCopy.maxSelection > 1
          ? answer.answerOptionIds
          : answer.answerOptionIds[0];
      } else {
        delete questionCopy.answer;
      }

      return questionCopy;
    });
  }, []);

  const getStartIndex = useCallback((questions, currentSection) => {
    const orderedSections = Object.values(MY_PROFILE_QUESTION_SECTIONS_V2);
    const currentSectionIndex = orderedSections.indexOf(currentSection);

    let startIndex = 1;
    for (let i = 0; i < currentSectionIndex; i++) {
      startIndex += questions.filter((q) => q.section === orderedSections[i]).length;
    }

    return startIndex;
  }, []);

  const getSectionQuestions = useCallback((questions) => {
    const orderedSections = Object.values(MY_PROFILE_QUESTION_SECTIONS_V2);
    return orderedSections
      .map((section) => {
        const sectionQuestions = questions.filter((q) => q.section === section);
        if (sectionQuestions.length === 0) return null;
        return {
          section,
          questions: sectionQuestions,
        };
      })
      .filter(Boolean);
  }, []);

  return {
    questions,
    answers,
    getStartIndex,
    getSectionQuestions,
    isLoading,
  };
};
